const INITIAL_STATE = {
	meetings: [],
	meeting: [],
	meetingsbb: [],
	meetingbb: []
}

const meetingsReducer = (state = INITIAL_STATE, action) => {
	switch(action.type){
		case 'MEETINGS_FETCH':
			return {
				...state, 
				meetings: action.payload
			}
		case 'MEETING_FETCH':
			return {
				...state, 
				meeting: action.payload
			}
		case 'MEETINGS_BB_FETCH':
			return {
				...state, 
				meetingsbb: action.payload
			}
		case 'MEETING_BB_FETCH':
			return {
				...state, 
				meetingbb: action.payload
			}
		default:
			return state
	}
}

export default meetingsReducer
